export const ARIA_LABEL_NAMESPACE = 'ariaLabels';
export const VIDEOBOX_MUTE_ARIA_LABEL_KEY = 'VideoBox_AriaLabel_Mute';
export const VIDEOBOX_MUTE_ARIA_LABEL_DEFAULT = 'Mute';
